import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { db } from "../../firebase.config";
import { collection, getDocs } from "firebase/firestore";
import { ScaleLoader } from "react-spinners";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const FeaturedSellers = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSellers = async () => {
      try {
        setLoading(true);
        const carsRef = collection(db, "Feature-Seller");
        const qSnap = await getDocs(carsRef);
        const carsArray = [];
        qSnap.forEach((doc) => {
          carsArray.push({ id: doc.id, ...doc.data() });
        });
        setSellers(carsArray);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchSellers();
  }, []);

  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
          Featured Showrooms
        </h2>
        
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <ScaleLoader color="#4F46E5" />
          </div>
        ) : (
          <>
            <Carousel 
              responsive={responsive}
              swipeable={true}
              draggable={true}
              showDots={false}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={3000}
              keyBoardControl={true}
              customTransition="all .5"
              transitionDuration={500}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile"]}
              itemClass="px-4 py-2"
            >
              {sellers.map((seller) => (
                <div 
                  key={seller.id}
                  className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 h-full flex flex-col"
                >
                  <div className="relative h-48 w-full overflow-hidden">
                    <img
                      src={seller.thumbnail}
                      alt={seller.sellerName}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                      onError={(e) => {
                        e.target.src = "https://via.placeholder.com/300x200?text=No+Image";
                      }}
                    />
                  </div>
                  <div className="p-6 flex-grow">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">
                      {seller.sellerName}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4 text-center">
                      {seller.address}
                    </p>
                  </div>
                  <div className="px-6 pb-6">
                    <Link to={`/seller-profile/${seller.id}`} className="block">
                      <Button
                        color="white"
                        bg="linear-gradient(to right, #2563eb, #1e40af)"
                        _hover={{
                          bg: "linear-gradient(to right, #1e40af, #1e3a8a)",
                        }}
                        className="w-full font-medium py-2 rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-md hover:shadow-lg"
                      >
                        View Listings
                      </Button>
                    </Link>
                  </div>
                </div>
              ))}
            </Carousel>
            
            <div className="flex justify-center mt-10">
              <Link to="/featured-sellers">
                <button className="bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold py-3 px-6 rounded-full shadow-lg hover:from-blue-700 hover:to-blue-900 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl inline-flex items-center">
                  View All Showrooms
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </button>
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default FeaturedSellers;